import {
  getAuth,
  NextOrObserver,
  onAuthStateChanged as _onAuthStateChanged,
  User,
  signInAnonymously as _signInAnonymously,
  getIdToken as _getIdToken,
  linkWithCredential as _linkWithCredential,
  EmailAuthProvider,
  signInWithEmailAndPassword as _signInWithEmailAndPassword,
  signInWithCredential as _signInWithCredential,
  signOut as _signOut,
  updateProfile,
  reload,
  AuthCredential,
  fetchSignInMethodsForEmail,
  sendPasswordResetEmail as _sendPasswordResetEmail,
} from '@firebase/auth';
import { auth } from '@/src/features/services/firebase/client/app';

export const onAuthStateChanged = (callback: NextOrObserver<User>) => {
  return _onAuthStateChanged(auth, callback);
};

export const getCurrentUser = () => {
  return auth.currentUser;
};

export const signInAnonymously = () => {
  return _signInAnonymously(auth);
};

export const signUpWithEmail = async (
  email: string,
  password: string,
  displayName: string,
  onSuccess: (user: User) => void,
) => {
  const credential = EmailAuthProvider.credential(email, password);
  if (auth.currentUser?.isAnonymous) {
    const userCredential = await _linkWithCredential(
      auth.currentUser,
      credential,
    );

    const { user } = userCredential;
    await updateProfile(user, { displayName });
    await reload(user);

    onSuccess(user);

    return auth.currentUser;
  } else {
    throw new Error('User must be anonymous to link accounts!');
  }
};

export const signInWithEmail = (email: string, password: string) => {
  return _signInWithEmailAndPassword(auth, email, password);
};

export const signOut = () => {
  return _signOut(auth);
};

export const getIdToken = (forceRefresh?: boolean) => {
  if (auth?.currentUser) {
    return _getIdToken(auth.currentUser, forceRefresh);
  } else {
    throw new Error('User must be anonymous or logged in to get ID token!');
  }
};

export const signInWithCredential = async (credential: AuthCredential) => {
  const currentUser = getCurrentUser();
  if (currentUser) {
    return _linkWithCredential(currentUser, credential);
  }
  return _signInWithCredential(auth, credential);
};
export const checkEmailExists = async (email: string): Promise<boolean> => {
  try {
    const auth = getAuth();
    const signInMethods = await fetchSignInMethodsForEmail(auth, email);
    return signInMethods.length > 0;
  } catch (error) {
    console.error('Error checking email:', error);
    return false;
  }
};

export const sendPasswordResetEmail = (email: string) => {
  return _sendPasswordResetEmail(auth, email);
};
